(() => {
  const STORAGE_PREFIX = "st_session_";

  // Keep this permissive enough for real Stripe Checkout Session IDs
  const STRIPE_SESSION_RE = /^cs_(test|live)_[A-Za-z0-9_]+$/;

  const configs = [
    {
      key: "pet",
      modal: "pet-modal",
      close: "pet-close",
      reopen: "pet-reopen",
      form: "pet-form",
      submit: "pet-submit",
      status: "pet-status",
    },
    {
      key: "com",
      modal: "com-modal",
      close: "com-close",
      reopen: "com-reopen",
      form: "com-form",
      submit: "com-submit",
      status: "com-status",
    },
    {
      key: "rec",
      modal: "rec-modal",
      close: "rec-close",
      reopen: "rec-reopen",
      form: "rec-form",
      submit: "rec-submit",
      status: "rec-status",
    },
  ];

  const el = (id) => document.getElementById(id);

  function normalizeTier(rawTier) {
    if (!rawTier) return null;
    const t = rawTier.toLowerCase().trim();

    if (t === "pet" || t === "petition") return "pet";
    if (t === "com" || t === "comp" || t === "composite") return "com";
    if (t === "rec" || t === "record") return "rec";

    return null;
  }

  function consumeUrlParam() {
    const params = new URLSearchParams(window.location.search);

    const sessionId = params.get("session_id") || params.get("session");

    const tier = normalizeTier(params.get("tier"));

    if (sessionId && tier && STRIPE_SESSION_RE.test(sessionId)) {
      sessionStorage.setItem(STORAGE_PREFIX + tier, sessionId);
    }

    // clean URL
    if (
      params.has("session_id") ||
      params.has("session") ||
      params.has("tier")
    ) {
      params.delete("session_id");
      params.delete("session");
      params.delete("tier");

      const clean =
        window.location.pathname +
        (params.toString() ? "?" + params.toString() : "") +
        window.location.hash;

      history.replaceState(null, "", clean);
    }
  }

  function getSession(key) {
    const val = sessionStorage.getItem(STORAGE_PREFIX + key);
    if (val && STRIPE_SESSION_RE.test(val)) return val;
    return null;
  }

  function isUnlocked(key) {
    return !!getSession(key);
  }

  function revoke(key) {
    sessionStorage.removeItem(STORAGE_PREFIX + key);
  }

  function init(c) {
    const modal = el(c.modal);
    const closeBtn = el(c.close);
    const reopenWrap = el(c.reopen);
    const reopenBtn = reopenWrap ? reopenWrap.querySelector("button") : null;
    const form = el(c.form);
    const submitBtn = el(c.submit);
    const statusEl = el(c.status);

    if (!modal || !form) return;

    const show = () => {
      modal.classList.remove("hidden");
      modal.setAttribute("aria-hidden", "false");
      if (reopenWrap) reopenWrap.classList.add("hidden");
      document.documentElement.classList.add("overflow-hidden");
    };

    const hide = () => {
      modal.classList.add("hidden");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("overflow-hidden");

      if (isUnlocked(c.key) && reopenWrap) {
        reopenWrap.classList.remove("hidden");
      }
    };

    hide();
    if (reopenWrap) reopenWrap.classList.add("hidden");

    if (isUnlocked(c.key)) show();

    if (reopenBtn) {
      reopenBtn.addEventListener("click", () => {
        if (isUnlocked(c.key)) show();
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener("click", hide);
    }

    modal.addEventListener("click", (e) => {
      if (e.target === modal) hide();
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && !modal.classList.contains("hidden")) {
        hide();
      }
    });

    form.addEventListener("submit", async (e) => {
      const sessionId = getSession(c.key);

      if (!sessionId) {
        e.preventDefault();
        if (statusEl)
          statusEl.textContent =
            "Session expired. Please complete payment first.";
        return;
      }

      if (form.dataset.submitting === "1") {
        e.preventDefault();
        return;
      }

      const endpoint = (form.getAttribute("action") || "").trim();
      if (!endpoint) {
        e.preventDefault();
        if (statusEl) statusEl.textContent = "Form endpoint missing.";
        return;
      }

      e.preventDefault();
      form.dataset.submitting = "1";

      const gotcha = form.querySelector("[name='_gotcha']");
      if (gotcha && gotcha.value) return;

      if (submitBtn) submitBtn.disabled = true;
      if (statusEl) statusEl.textContent = "Submitting…";

      try {
        const fd = new FormData(form);
        fd.append("stripe_session", sessionId);

        const res = await fetch(endpoint, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: fd,
        });

        if (!res.ok) throw new Error("failed");

        revoke(c.key);

        if (statusEl) statusEl.textContent = "Submitted. Thank you.";
        form.reset();

        setTimeout(() => {
          if (statusEl) statusEl.textContent = "";
          modal.classList.add("hidden");
          modal.setAttribute("aria-hidden", "true");
          if (reopenWrap) reopenWrap.classList.add("hidden");
          document.documentElement.classList.remove("overflow-hidden");
        }, 1500);
      } catch (err) {
        if (statusEl) statusEl.textContent = "Submit failed. Please try again.";
        console.error(err);
      } finally {
        if (submitBtn) submitBtn.disabled = false;
        form.dataset.submitting = "0";
      }
    });
  }

  consumeUrlParam();
  configs.forEach(init);
})();
